import { html } from 'lit';
import type { LandingContent } from '../../shared/content/landingContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import { editorNodeClass, editorNodeClick, editorNodePointerDown, editorNodeStyle, type LandingEditorRenderOptions } from '../editor/landingEditorRender.js';
import './companyObjectionsElement.js';

export const companyObjectionsSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => {
  const story = content.companyObjections;
  const text = (field: string, value: string, tag: 'p' | 'h2' | 'h3' = 'p', className = '') => editorSemanticText({ editor, elementId: `companyObjections.${field}`, fallbackTag: tag, className, content: value });
  return html`
    <vp-company-objections data-motion=${editor?.mode === 'editor' ? 'off' : story.motion}
      class=${editorNodeClass(editor, 'section.companyObjections', 'vp-company-objections')} style=${editorNodeStyle(editor, 'section.companyObjections')}
      @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.companyObjections', event)}
      @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.companyObjections', event)}>
      <div class="vp-company-objections-grid">
        <header class="vp-company-objections-heading">
          ${text('title', story.title, 'h2', 'vp-company-section-title')}
          ${text('intro', story.intro)}
          ${story.cards.length ? html`<div class="vp-company-story-progress" aria-hidden="true"><span data-story-current>01</span><span> / ${String(story.cards.length).padStart(2, '0')}</span><div><i></i></div></div>` : ''}
        </header>
        <div class=${editorNodeClass(editor, 'companyObjections.cards', 'vp-company-objection-cards')} style=${editorNodeStyle(editor, 'companyObjections.cards')}>
          ${story.cards.map((card, index) => {
            const id = `companyObjections.cards.${index}`;
            return html`<article data-story-card class=${editorNodeClass(editor, id, 'vp-company-objection-card')} style=${editorNodeStyle(editor, id)}
              @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, id, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, id, event)}>
              <div class="vp-company-objection-top"><span aria-hidden="true">${String(index + 1).padStart(2, '0')}</span>${text(`cards.${index}.chapter`, card.chapter, 'p', 'vp-company-eyebrow')}</div>
              ${text(`cards.${index}.question`, card.question, 'p', 'vp-company-objection-question')}
              ${text(`cards.${index}.title`, card.title, 'h3')}
              ${text(`cards.${index}.text`, card.text)}
              <div class="vp-company-objection-takeaway">
                ${card.metric || editor?.mode === 'editor' ? text(`cards.${index}.metric`, card.metric, 'p', 'vp-company-objection-metric') : ''}
                ${text(`cards.${index}.metricLabel`, card.metricLabel)}
              </div>
            </article>`;
          })}
        </div>
      </div>
      ${text('transition', story.transition, 'p', 'vp-company-story-transition')}
    </vp-company-objections>
  `;
};
